import { PATHS } from '@/shared/constants/app/routes.constant.ts';

/** 판 고정 쿼리 키. 이 값이 URL 에 있으면 그 판이 영구히 고정된다. */
export const EDITION_PARAM = 'edition';
/** 검색어 쿼리 키. 결과 목록이 살아 있어야 상세에서 뒤로 갔을 때 자리를 안 잃는다. */
export const QUERY_PARAM = 'q';
export const DIVISION_PARAM = 'division';
export const RESOURCE_PARAM = 'resource';
export const CHANGED_PARAM = 'changed';

/**
 * 항목 링크.
 *
 * `edition` 을 넘기면 **판 고정 링크**가 된다 — 견적서 근거로 붙이는 링크는
 * 반드시 이쪽이어야 한다. 안 넘기면 "현행" 링크라 반기마다 내용이 바뀐다.
 * 국가법령정보센터가 현행 조문 URL 과 시행일자 고정 URL 을 따로 두는 것과 같다.
 */
export function pumsemItemPath(
  division: string,
  code: string,
  edition?: string | null,
): string {
  const base = PATHS.pumsemItem(division, code);
  return edition ? `${base}?${EDITION_PARAM}=${edition}` : base;
}

export function pumsemDiffPath(
  division: string,
  code: string,
  edition?: string | null,
): string {
  const base = PATHS.pumsemDiff(division, code);
  return edition ? `${base}?${EDITION_PARAM}=${edition}` : base;
}

/**
 * 지금 보고 있는 검색 조건을 유지한 채 항목으로 이동하는 링크.
 * 상세에서 뒤로 가면 방금 훑던 결과 목록이 그대로 있어야 한다.
 */
export function pumsemItemPathWithSearch(
  division: string,
  code: string,
  search: URLSearchParams,
): string {
  const query = new URLSearchParams(search).toString();
  return `${PATHS.pumsemItem(division, code)}${query ? `?${query}` : ''}`;
}
